import axios from 'axios';

const API_URL = 'api/product/';

class ProductService {
    getAll() {
        return axios.get(API_URL + 'get');
    }

    get(id) {
        return axios.get(API_URL + 'get/' + id);
    }
}

const productService = new ProductService();
export default productService;